import * as React from 'react';
import { NextPage } from 'next';
import { Dispatch } from 'redux';

import { wrapper } from 'ducks';
import { fetchProductSummariesServerSide, fetchSettingsServerSide } from 'ducks/server';
import { BookingWidgetEmbedLayout } from 'components/BookingWidgetEmbedLayout/BookingWidgetEmbedLayout';
import { EmbeddedMultiProductCalendar } from 'components/EmbeddedMultiProductCalendar/EmbeddedMultiProductCalendar';
import { withSSR } from 'withSSR';
import { getI18nServerSideProps } from 'i18n';
import { detectLocale } from 'i18n-server';
import { selectLanguageOptions } from 'ducks/server/settings';

const MultiProductCalendar: NextPage = () => {
  return (
    <>
      <BookingWidgetEmbedLayout>
        <style jsx global>
          {`
            body {
              background-color: transparent !important;
            }
          `}
        </style>
        <EmbeddedMultiProductCalendar />
      </BookingWidgetEmbedLayout>
    </>
  );
};

export const getServerSideProps = wrapper.getServerSideProps(
  async ({ params, req, res, store }) => {
    const apiKey = params?.apiKey as string;

    let locale = await detectLocale(req, res);

    // Fetch settings using detected language
    const dispatch: Dispatch<any> = store.dispatch;
    await dispatch(fetchSettingsServerSide(apiKey, params?.id as string, locale));

    // Verify that the detected language is in the supplier's supported languages. If it isn't,
    // default to the first supported language and refetch settings.
    const langOptions = selectLanguageOptions(store.getState());
    if (langOptions.length > 0 && !langOptions.some((langOpt) => langOpt.iso === locale)) {
      locale = langOptions[0].iso;
      await dispatch(fetchSettingsServerSide(apiKey, params?.id as string, locale));
    }

    await dispatch(fetchProductSummariesServerSide(apiKey, locale));

    const i18nProps = await getI18nServerSideProps(locale);

    return {
      props: {
        ...i18nProps,
      },
    };
  }
);

export default withSSR()(MultiProductCalendar);
